/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteAnalytics } from './SiteAnalytics';
import {
    SiteAnalyticsFromJSON,
    SiteAnalyticsFromJSONTyped,
    SiteAnalyticsToJSON,
    SiteAnalyticsToJSONTyped,
} from './SiteAnalytics';

/**
 * 
 * @export
 * @interface PaginatedSiteAnalyticsList
 */
export interface PaginatedSiteAnalyticsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteAnalyticsList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteAnalyticsList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteAnalyticsList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<SiteAnalytics>}
     * @memberof PaginatedSiteAnalyticsList
     */
    results: Array<SiteAnalytics>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteAnalyticsList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedSiteAnalyticsList interface.
 */
export function instanceOfPaginatedSiteAnalyticsList(value: object): value is PaginatedSiteAnalyticsList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSiteAnalyticsListFromJSON(json: any): PaginatedSiteAnalyticsList {
    return PaginatedSiteAnalyticsListFromJSONTyped(json, false);
}

export function PaginatedSiteAnalyticsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSiteAnalyticsList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(SiteAnalyticsFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedSiteAnalyticsListToJSON(json: any): PaginatedSiteAnalyticsList {
    return PaginatedSiteAnalyticsListToJSONTyped(json, false);
}

export function PaginatedSiteAnalyticsListToJSONTyped(value?: PaginatedSiteAnalyticsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SiteAnalyticsToJSON)),
        'num_pages': value['numPages'],
    };
}

